module.exports = __webpack_public_path__ + "static/media/lost.d572e780.wav";